module.exports = {"152531100":"大北沟镇","152531101":"多伦诺尔镇","152531102":"滦源镇","152531201":"蔡木山乡","152531202":"西干沟乡","152531400":"多伦新型工业化化工区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152531.json
// module id = 582
// module chunks = 0